import { render } from "./ShowConfig.vue?vue&type=template&id=1849ab9a&scoped=true"
import script from "./ShowConfig.vue?vue&type=script&lang=js"
export * from "./ShowConfig.vue?vue&type=script&lang=js"

import "./ShowConfig.vue?vue&type=style&index=0&id=1849ab9a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1849ab9a"]])

export default __exports__